export const requiredValidator = (value) => (value ? '' : 'This field is required *')

export const emailValidator = (value) => {
  if (value) {
    const emailRegex = new RegExp(/\S+@\S+\.\S+/);
    return emailRegex.test(value) ? "" : "Please enter a valid email.";
  }
  return 'This field is required.'
}